/**
 * Checks if WebGL is available in the browser.
 * @returns Object with availability status and error message if unavailable
 */
export function checkWebGLAvailability(): {
  available: boolean;
  error?: string;
} {
  // Check if we're in a browser environment
  if (typeof window === "undefined") {
    return {
      available: false,
      error: "Not in browser environment",
    };
  }

  // Try to get WebGL context
  try {
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl") || canvas.getContext("webgl2") || null;

    if (!gl) {
      return {
        available: false,
        error: "WebGL context could not be created",
      };
    }

    // Additional check: verify WebGL is actually functional
    // Some browsers may create a context but it's not usable
    const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
    if (debugInfo) {
      // If we can get debug info, WebGL is working
      return { available: true };
    }

    // Even without debug info, if we have a context, it should work
    return { available: true };
  } catch (error) {
    return {
      available: false,
      error: error instanceof Error ? error.message : "Unknown error",
    };
  }
}
